import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'cva-confirm-dailog',
    templateUrl: './confirm-dailog.component.html',
    styleUrls: ['./confirm-dailog.component.scss'],
    
})
export class ConfirmDailogComponent {
  constructor(public readonly dialogRef: MatDialogRef<ConfirmDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string , buttonName: string}) {
  }

  closeDialog(flag: boolean) {
    this.dialogRef.close(flag);
  }
}
